"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorComponent = _interopRequireDefault(require("../../ErrorComponent"));

var Error = function Error(_ref) {
  var error = _ref.error,
      children = _ref.children,
      component = _ref.component,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["error", "children", "component", "type"]);
  var Component = component || _ErrorComponent["default"];

  if (error) {
    if (Array.isArray(error)) {
      return error.map(function (error, i) {
        return _react["default"].createElement(Component, (0, _extends2["default"])({
          key: i,
          type: type
        }, rest), error.message);
      });
    } else if ((0, _typeof2["default"])(error) === 'object') {
      return [error].map(function (error, i) {
        return _react["default"].createElement(Component, (0, _extends2["default"])({
          key: i,
          type: type
        }, rest), error.message);
      });
    } else if (typeof error === 'string') {
      return _react["default"].createElement(Component, (0, _extends2["default"])({
        type: type
      }, rest), error);
    } else {
      return null;
    }
  } else if (children !== undefined) {
    return _react["default"].createElement(Component, (0, _extends2["default"])({
      type: type
    }, rest), children);
  } else {
    return null;
  }
};

Error.propTypes = {
  component: _propTypes["default"].func,
  error: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object, _propTypes["default"].bool, _propTypes["default"].string]),
  children: _propTypes["default"].any,
  type: _propTypes["default"].string
};
Error.defaultProps = {
  type: 'form'
};
var _default = Error;
exports["default"] = _default;